
import customProtocolCheck from "custom-protocol-check";

import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import * as bootstrap from "bootstrap";
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import vueinstallapp from './../Shared/vueinstallapp.vue';
import { createPinia } from 'pinia';

export class InstallButLinks {
    public  name: string = "";
    public  url: string = "";
    public description: string = "";
}

export class ManualInstallButLinks {
    public NameAgent: string = "";
    public UrlAgent: string = "";
    public DescriptionAgent: string = "";
    public NameEdgeView: string = "";
    public UrlEdgeView: string = "";
    public DescriptionEdgeView: string = "";
}

export class InstallAppApiViewModel {
    public installautobut: InstallButLinks | null = null;
    public m_configversionstr: string = "";
    public ManualInstall32: ManualInstallButLinks | null = null;
    public ManualInstall64: ManualInstallButLinks | null = null;
}

export const MixinDetect = defineComponent({
    components: {
        vueinstallapp
    },
    data() {
        return {
            loadingstartdetect: false,
            installmode:false,
            dc_descpilotesreferer:null,
            viewappli: null as InstallAppApiViewModel | null
        };
    },
    mounted() {
    },
    methods: {
        DetectionModalLoad(url: string) {
            let self = this;
            axios.get<InstallAppApiViewModel>(url).then(function (response: AxiosResponse<InstallAppApiViewModel>) {
                if (response.data !== null) {
                    self.installmode = true;
                    self.viewappli = response.data;
                }
            });


        },

        DCInstallModelApplication(url: string) {

            this.DetectionModalLoad(url);
            let elt = document.getElementById('dc_installappdialog');
            if (elt !== null) {
                let modal = new bootstrap.Modal(elt, {});
                modal.show();
            }
        },

        StartDetect(lancurrent: string, isdctools: boolean) {
            this.loadingstartdetect = true;
            customProtocolCheck(
                jQuery("#dc_start_detectbut")?.attr("href") ?? "",
                () => {
                    this.DCInstallModelApplication(`/api/v1.0/startdetection/InstallApp?lancurrent=${lancurrent}&isdctools=${isdctools}`);
                    this.loadingstartdetect = false;
                },
                () => {
                    this.loadingstartdetect = false;
                }
            );
            return false;
        },

        InstallApp(lancurrent: string, isdctools: boolean) {
            this.DCInstallModelApplication(`/api/v1.0/startdetection/InstallApp?lancurrent=${lancurrent}&isdctools=${isdctools}`);
        }
    }
});


export class StartDetectionComponent {
    public Init() {
        DCApp.mixins = [MixinDetect];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).StartDetectionComponent = function () { return new StartDetectionComponent(); };